import './styles.css'
import { Game } from './game/game'
import { registerPwa } from './pwa/register'

const canvas = document.getElementById('game') as HTMLCanvasElement
const game = new Game(canvas)
void game.init()
registerPwa()
